/**
 * Funktion, um einen Namespace zu definieren.
 *
 * @param {string} ns Namespace als Punkt separierter String.
 * @returns {Object} Gibt den definierten Namespace zurueck.
 */

var namespace = function (ns) {

    var parts       = ns.split('.'),
        parent      = window,
        currentPart = '',
        i           = 0,
        length      = parts.length;

    for (/* omitted */; i < length; i++) {
        currentPart         = parts[i];
        parent[currentPart] = parent[currentPart] || {};
        parent              = parent[currentPart];
    }

    return parent;
};

window.namespace = namespace;
